export const L10N = {
  ACTION_MORE_INFO: { id: 'common.action.more_info' },

  LABEL_FREE: { id: 'common.label.free' },
  LABEL_TOTAL: { id: 'common.label.total' },
};
